interface InitialsAvatarProps {
  first: string;
  last: string;
  size?: 'sm' | 'md';
}

export function InitialsAvatar({ first, last, size = 'sm' }: InitialsAvatarProps) {
  const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || '·';
  const sizeClasses = size === 'md' ? 'h-12 w-12 text-sm' : 'h-8 w-8 text-[11px]';
  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-full bg-secondary font-medium text-secondary-foreground ${sizeClasses}`}
    >
      {initials}
    </span>
  );
}
